// extracted by mini-css-extract-plugin
export var aboveInput = "_kg-0";
export var actionButton = "_kg-5";
export var actionButtonContainer = "_kg-1";
export var actionIcon = "_kg-6";
export var aiInfoContainer = "_kg-2";
export var attachmentWrapper = "_kg-7";
export var bold = "_kg-3";
export var checkIcon = "_kg-8";
export var clickingRecipientBar = "_kg-11";
export var commentThreadSwitch = "_kg-a";
export var draftImage = "_kg-b";
export var draftImageContainer = "_kg-c";
export var draftImages = "_kg-e";
export var editButton = "_kg-g";
export var editor = "_kg-f";
export var editorContainer = "_kg-y";
export var editorErrorTooltipWrapper = "_kg-9";
export var headerDivider = "_kg-h";
export var icon = "_kg-i";
export var info = "_kg-j";
export var internal = "_kg-n";
export var internalDivider = "_kg-k";
export var internalMessage = "_kg-l";
export var messageInputCard = "_kg-m";
export var messageInputForm = "_kg-o";
export var messageInputFormInternal = "_kg-p";
export var options = "_kg-q";
export var publicMessageCustomer = "_kg-s";
export var publicMessageMerchant = "_kg-r";
export var removeImageButton = "_kg-d";
export var replyButtons = "_kg-t";
export var showSignatureButton = "_kg-u";
export var spinner = "_kg-v";
export var verticalButtonDivider = "_kg-4";
export var visibilitySelector = "_kg-w";
export var warning = "_kg-x";
export var wrappingText = "_kg-z";
export var writingInternalNoteTopBorder = "_kg-10";